/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import AccountPropertyTypeEnum from './AccountPropertyTypeEnum';





/**
* The AccountPropertyDTO model module.
* @module model/AccountPropertyDTO
* @version 0.7.15
*/
export default class AccountPropertyDTO {
    /**
    * Constructs a new <code>AccountPropertyDTO</code>.
    * @alias module:model/AccountPropertyDTO
    * @class
    * @param propertyType {module:model/AccountPropertyTypeEnum} 
    * @param values {Array.<Object>} The address, transaction type or mosaic id to filter.
    */

    constructor(propertyType, values) {
        

        
        



        this['propertyType'] = propertyType;this['values'] = values;

        
    }

    /**
    * Constructs a <code>AccountPropertyDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/AccountPropertyDTO} obj Optional instance to populate.
    * @return {module:model/AccountPropertyDTO} The populated <code>AccountPropertyDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountPropertyDTO();

            
            
            

            if (data.hasOwnProperty('propertyType')) {
                obj['propertyType'] = AccountPropertyTypeEnum.constructFromObject(data['propertyType']);
            }
            if (data.hasOwnProperty('values')) {
                obj['values'] = ApiClient.convertToType(data['values'], [Object]);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/AccountPropertyTypeEnum} propertyType
    */
    propertyType = undefined;
    /**
    * The address, transaction type or mosaic id to filter.
    * @member {Array.<Object>} values
    */
    values = undefined;








}


